<template>
	<popup class="integration-settings-popup" :title="localIntegration.caption+' configuration'" @close="closePopup">
		<template v-slot:content>
			<div class="__content">
				<div class="automation-item" :class="localIntegration.name">
					<div class="left">
						<div class="img-wrap" v-if="integration.small_image">
							<img style="height: 50px;max-width: 50px;"
							     :src="'data:image/png;base64,'+integration.small_image" alt="">
						</div>
						<div class="text">
							<strong>{{integration.caption}}</strong>
							<p>{{integration.description}}</p>
						</div>
					</div>
					<div class="right">
						<label class="switch_checkbox_item">
							<input type="checkbox" id="checkbox"
							       :checked="localUserIntegration.active"
							       v-model="localUserIntegration.active">
							<div class="switch_checkbox"><span></span></div>
						</label>
					</div>
				</div>

				<template v-if="integration.id === 5 || integration.id === 6">
					<div class="margin-b-20">
						<input-field class="margin-t-10"
						             v-if="integration.id === 5"
						             label="Your store domain name"
						             info="Usually something like 'mystorename.myshopify.com' (without the https:// part)"
						             v-model="localUserIntegration.config.store_url" />
					</div>

					<div class="connect_to_stripe_box w100" v-if="localUserIntegration.config.token && localUserIntegration.config.token !== ''">
						<h3>Connected to {{integration.caption}}</h3>
						<div class="connect_to_stripe_box_innner connect">
							<p>Click the <b>"Disconnect"</b> button below to restrict access to {{integration.name}}</p>
							<v-button :loading="connecting" label="Disconnect"
							          @click.prevent="disconnectFromService(integration.id)" />
						</div>
					</div>

					<div class="connect_to_stripe_box w100" v-else>
						<h3>Connect to {{integration.caption}}</h3>
						<div class="connect_to_stripe_box_innner connect">
							<p>Click the <b>"Connect"</b> button below to authorize Funnelish™ to access
								{{integration.name}}</p>
							<v-button :loading="connecting" label="Connect" @click.prevent="connectToService(integration.id)"/>
						</div>
					</div>
				</template>
				<div v-else class="form-group mb-24 with_top_block" v-for="(item, index) in localIntegration.config" :key="index">
					<span class="form_group_top_block">{{item.caption}}</span>
					<input type="text" v-model="localUserIntegration.config[item.name]" class="control-input">
				</div>
				<p class="btm-descr">
					Feel free to contact us or start a new thread in <a href="https://community.funnelish.com">the community</a> if have any questions
					about setting up & using this integration.
				</p>

			</div>
		</template>

		<template v-slot:actions>
			<v-button slim border @click="$emit('back')" label="Back to automation list"/>
			<v-button slim :loading="saving" @click="save" label="Save and continue" />
		</template>
	</popup>
</template>

<script>
import {mapGetters} from "vuex"
import API from "@/api"
import InputField from "@/components/base/input-field";
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
export default {
	name: "integration-settings-popup",
	components: {Popup, VButton, InputField},
	props:{
		integration:{},
	},
	mixins: [API],
	data() {
		return {
			saving: false,
			connecting: false,
			checked: false,
			newData: {},
			timer: null,
			localUserIntegration:{},
			localIntegration:{},
		}
	},
	computed:{
		userIntegration() {
			return this.integration ? this.integration.user_integration || {} : {};
		}
	},
	methods: {
		clearTimer() {
			if (this.timer)
				clearInterval(this.timer);
		},
		openUrl(url) {
			let self = this;
			this.loadingConnection = true;
			let win = window.open(url, "_blank");
			this.timer = setInterval(async function() {
				if (!win || win.closed) {
					self.connecting = false;
					self.clearTimer();
					window.waitingForIntegration = null;
					self.$emit('done');
				}
			}, 500);
		},
		async connectToService(id) {
			try {
				this.connecting = true;
				var result = await this.api.integrations.connect(this.localIntegration.name, {arg1: this.localUserIntegration.config.store_url})
				if (result.success) {
					window.waitingForIntegration = this.integration.id;
					this.openUrl(result.result);
				} else throw result;
			} catch (e) {
				this.connecting = false;
				this.$error(e)
			} finally {
			}
		},
		async disconnectFromService(id) {
			try {
				this.connecting = true;
				var result = await this.api.integrations.disconnect(this.localIntegration.name, {
					arg1: '',
					arg2: "",
					id: 0
				});
				if (result.success) {
					this.$emit('done')
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.connecting = false;
			}
		},
		closePopup() {
			this.$emit('close')
		},
		async save() {
			try {
				this.saving = true;

				let data = JSON.parse(JSON.stringify(this.localUserIntegration));
				data.config = JSON.stringify(data.config);
				let result = await this.api.integrations.updateUserIntegration(this.localIntegration.id, data);
				this.$emit('done', result)
			} catch (e) {
				this.$error(e)
			} finally {
				this.saving = false;
			}
		},
	},
	beforeDestroy() {
		this.clearTimer();
	},
	created() {
		if (this.userIntegration) {
			this.localUserIntegration = JSON.parse(JSON.stringify(this.userIntegration))
			this.localUserIntegration.config = JSON.parse(this.localUserIntegration.config)
		} else
			this.localUserIntegration = {}

		if (this.integration) {
			this.localIntegration = JSON.parse(JSON.stringify(this.integration))
			this.localIntegration.config = JSON.parse(this.localIntegration.config)
		}
	}
}
</script>
<style lang="scss" scoped>
.integration-settings-popup {
	.automation-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #F6F9FE;
		border-radius: 8px;
		padding: 10px 25px;
		position: relative;
		margin-bottom: 25px;
		.left {
			display: flex;
			align-items: center;
		}

		strong {
			font-weight: 500;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: 0.02em;
			color: $darker-grey;
			display: block;
			margin-bottom: 3px;
		}

		p {
			font-size: 13px;
			line-height: 150%;
			letter-spacing: 0.02em;
			margin: 0;
			color: #636A7B;
		}

		.img-wrap {
			display: flex;
			margin-right: 15px;
		}
		.img-wrap {
			max-width: 70px;
			img {
				width: 30px;
				height: 30px;
				object-fit: scale-down;
			}
		}
	}
}
.connect_to_stripe_box {
	border-radius: 15px;
	background: $light-blue;
	padding: 15px;
}
</style>
